export default __webpack_public_path__ + "static/media/TnB0030.0af0d920.jpg";